import HighlightUtils from '@shared/publication/HighlightUtils';
import Locator from '@shared/publication/locator.mjs';
import get from 'lodash/get';

function convertLocatorToSelectionRange(locator) {
  const deserializedLocator = Locator.deserialize(locator);
  return HighlightUtils.createSelectionStringFromLocator(deserializedLocator);
}

function createHighlight(rangeLocator, query) {
  const standAloneWords = get(query, 'standAloneWords', null);
  const stems = get(query, 'stems', null);
  const quotes = get(query, 'quotes', null);
  return {
    stems: standAloneWords || stems || [],
    quotes: quotes || [],
    selectionString: rangeLocator
  };
}

function buildOpenParameters(publication, locator, query, reload) {
  const openOffset = -Math.round(window.innerHeight / 3);
  const openParams = {
    slug: publication.slug || publication.publicationId,
    paragraphId: publication.paraId,
    openOffset,
    reload
  };

  const publicationLocator = publication.bookMeta
    ? publication.bookMeta.locator
    : publication.locator;
  if (publicationLocator) {
    const rangeLocator = convertLocatorToSelectionRange(publicationLocator);
    const highlight = createHighlight(rangeLocator, query);
    openParams.highlight = highlight;
    openParams.paragraphId = publicationLocator;
  }
  openParams.searchNavigation = true;
  return openParams;
}

export default {
  buildOpenParameters
};
